import { useCallback } from 'react';
import { useIntercom } from 'react-use-intercom';

import { parseTemplate } from '../utils/functions';

const composeMetaData = (template, data, extraTemplateParams) => ({
	Description: parseTemplate(template, { ...data, ...extraTemplateParams }),
	...data,
});

export default function useTrackEvent() {
	const { trackEvent, boot } = useIntercom();

	const higherOrderTrackEvent = useCallback(
		(event, template, metaData = {}, extraTemplateParams = {}) => {
			trackEvent(event, composeMetaData(template, metaData, extraTemplateParams));
		},
		[trackEvent],
	);

	const higherOrderBoot = useCallback(
		(...args) => {
			boot(...args);
		},
		[boot],
	);

	return {
		trackEvent: higherOrderTrackEvent,
		boot: higherOrderBoot,
	};
}
